import emptyContentImageSmall from '@juvare/common-web-ui/assets/emptyContentImageSmall.svg';
import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { AlertCard } from '../../AlertCard';
export const ListContent = ({ dataTableProps, noAlertsLabel, onReloadList }) => {
    if (dataTableProps.rows.length > 0) {
        return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1, p: 2 } }, dataTableProps.rows.map((alert) => {
            var _a;
            const checked = !!((_a = dataTableProps.selectedRowIds) === null || _a === void 0 ? void 0 : _a.includes(alert.id));
            return (React.createElement(AlertCard, { key: alert.id, alert: alert, checked: checked, selected: dataTableProps.activeRowId === alert.id, onCardClick: () => {
                    var _a;
                    (_a = dataTableProps.onRowClick) === null || _a === void 0 ? void 0 : _a.call(dataTableProps, alert);
                }, onIconClick: () => {
                    var _a;
                    (_a = dataTableProps.onRowSelectionChange) === null || _a === void 0 ? void 0 : _a.call(dataTableProps, alert, !checked);
                }, onReloadList: onReloadList }));
        })));
    }
    else if (dataTableProps.rows.length === 0 && dataTableProps.loading) {
        return (React.createElement(Box, { sx: { py: '140px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 } },
            React.createElement(CircularProgress, { size: 54 })));
    }
    else if (dataTableProps.rows.length === 0 && !dataTableProps.loading) {
        return (React.createElement(Box, { sx: { py: '120px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 } },
            React.createElement("img", { src: emptyContentImageSmall, alt: '', style: { maxWidth: '100%' } }),
            React.createElement(Typography, { variant: 'subtitle1' }, noAlertsLabel)));
    }
    else {
        return null;
    }
};
